import { render, staticRenderFns } from "./ModalAceiteTermos.vue?vue&type=template&id=5294ad28&"
import script from "./ModalAceiteTermos.vue?vue&type=script&lang=js&"
export * from "./ModalAceiteTermos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports